import { useMutation } from 'react-query';
import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { MediaCreateDoc } from 'types/media';

export const useCreateMedia = () => {
  const authState = useAuthSelector();

  return useMutation(async (mediaFullDoc: MediaCreateDoc) =>
    sdk.media.mutate.create(mediaFullDoc, authState?.auth_token),
  );
};
